"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterFuncs = exports.wujiFilter = void 0;
const lodash_1 = require("lodash");
const defaultOptions = {
    type: 'and',
    caseSensitive: true,
    strict: true,
};
function wujiFilter(array, filter, userOptions = 'and') {
    if (filter.length <= 0) {
        return [...array];
    }
    let options = Object.assign({}, defaultOptions);
    if (typeof userOptions === 'string') {
        options.type = userOptions;
    }
    if (userOptions && typeof userOptions === 'object') {
        options = Object.assign(Object.assign({}, options), userOptions);
    }
    const { type } = options;
    let data = [].concat(array);
    if (type === 'and') {
        filter.forEach((filterItem) => {
            const func = exports.filterFuncs[filterItem.o];
            data = data.filter((item) => {
                const value = lodash_1.get(item, filterItem.k);
                const [itemValue, v] = getFilterValues(value, filterItem.v, options);
                return func(itemValue, v, options);
            });
        });
    }
    if (type === 'or') {
        data = data.filter(item => filter.some((filterItem) => {
            const func = exports.filterFuncs[filterItem.o];
            const value = lodash_1.get(item, filterItem.k);
            const [itemValue, v] = getFilterValues(value, filterItem.v, options);
            return func(itemValue, v, options);
        }));
    }
    return data;
}
exports.wujiFilter = wujiFilter;
function toString(value, lowerCase = false) {
    if (value === null || value === undefined)
        return '';
    const str = typeof value === 'string' ? value : String(value);
    if (lowerCase) {
        return str.toLowerCase();
    }
    return str;
}
function getFilterValues(itemValue, v, options) {
    // 不区分大小写就都转成小写
    if (typeof itemValue === 'string' && !options.caseSensitive) {
        const itemString = toString(itemValue, true);
        const vString = toString(v, true);
        return [itemString, vString];
    }
    return [itemValue, v];
}
exports.filterFuncs = {
    // eslint-disable-next-line eqeqeq
    '=': (item, val, options) => (options.strict ? item === val : item == val),
    // eslint-disable-next-line eqeqeq
    '!=': (item, val, options) => (options.strict ? item !== val : item != val),
    '>': (item, val) => item > val,
    '>=': (item, val) => item >= val,
    '<': (item, val) => item < val,
    '<=': (item, val) => item <= val,
    '%%': (item, val) => toString(item).includes(toString(val)),
    '=%': (item, val) => toString(item).startsWith(toString(val)),
    '%=': (item, val) => toString(item).endsWith(toString(val)),
    '!%': (item, val) => !toString(item).includes(toString(val)),
};
